.boardRow {
    display: flex;
    text-align: center;
    justify-content: center;
}
